<app-modal (closeEmitter)="closeInfusePot()" [showModal]="showInjectPotModal">
  <h2 class="border-b font-bold">INFUSE POT</h2>

  <div class="mt-10 flex flex-col">
    <label class="font-bold">Amount <span class="text-red-500">*</span></label>
    <div class="input-wrapper mt-3">
      <input
        type="number"
        [(ngModel)]="infusionAmount"
        min="0"
        class="ib-input"
        placeholder="Enter amount to infuse to pot."
      />
      <svg-icon src="assets/svg/icons/Coins.svg"></svg-icon>
    </div>
  </div>

  <div class="mt-10 flex items-center justify-end space-x-2 font-semibold">
    <button
      class="secondary-btn flex h-10 items-center border border-black"
      (click)="closeInfusePot()"
    >
      Cancel
    </button>
    <button
      class="primary-btn flex h-10 items-center"
      (click)="confirm()"
      [disabled]="infusionAmount <= 0"
    >
      Confirm
    </button>
  </div>
</app-modal>
